import React from "react";
import { Link } from "react-router-dom";

const AuthLayout = ({ title, subtitle, children }) => {
  return (
    <div className="min-h-screen flex flex-col bg-gray-50">
      {/* --------------------------------------------------
         HEADER / BRAND
      -------------------------------------------------- */}
      <header className="pt-10 pb-6 text-center">
        <Link to="/" className="inline-flex flex-col items-center">
          {/* 🔰 LOGO (REPLACES TEXT BRANDING) */}
          <img
            src="/assets/logo/mdih-no-tm.png"
            alt="MDIH – Million Dollar Innovation Hub"
            style={{ height: 100 }}
          />
        </Link>
      </header>

      {/* --------------------------------------------------
         AUTH CARD
      -------------------------------------------------- */}
      <main className="flex-1 flex items-start justify-center px-4">
        <div className="w-full max-w-md bg-white rounded-xl shadow-sm border p-8">
          {title && (
            <h1 className="text-2xl font-semibold text-gray-900 text-center">
              {title}
            </h1>
          )}

          {subtitle && (
            <p className="text-sm text-gray-500 text-center mt-2">
              {subtitle}
            </p>
          )}

          <div className="mt-6">{children}</div>
        </div>
      </main>

      {/* --------------------------------------------------
         FOOTER / TRUST
      -------------------------------------------------- */}
      <footer className="py-6 text-center text-xs text-gray-400">
        <div className="flex items-center justify-center gap-3">
          <span>© {new Date().getFullYear()} MDIH</span>
          <span>·</span>
          <a
            href="/terms"
            target="_blank"
            rel="noopener noreferrer"
            className="hover:text-gray-600"
          >
            Terms
          </a>
          <span>·</span>
          <a
            href="/privacy"
            target="_blank"
            rel="noopener noreferrer"
            className="hover:text-gray-600"
          >
            Privacy
          </a>
        </div>
      </footer>
    </div>
  );
};

export default AuthLayout;
